import { gql } from '@apollo/client';

export const PROJECT_FIELDS = gql`
  fragment ProjectFields on Project {
    id
    projectName
    projectNumber
    city
    state
    countryCode
    type
    numberOfDepartments
    numberOfScenarios
    isLinkedToBenchmarkReport
    year
    startYear
    clientMoveInYear
    isHeadquarters
    currentUserRole
    organizationId
    requiresRequestToJoin
    status
    updatedAt
    insertedAt
    isMarkedAsFavoriteByUser
    hasMissingBenchmarkData
    headcountType
    archived
    allowBlankLocation
    lastEditor {
      id
      name
      isSuperAdmin
    }
    client {
      id
      name
      industry {
        id
        name
      }
    }
    createdByUser {
      id
      name
      email
      hasAvatar
      thumbnailS3Path
    }
    projectOwner {
      id
      name
      email
      numberOfProjects
      numberOfTeams
      officeLocation
      professionalRole
      hasAvatar
      thumbnailS3Path
      isActive
    }
    buildings {
      id
      index
      city
      state
      countryCode
      streetAddress
      squareFeet
      circulationPercentage
      circulation
      programSubtotalUsf
      programmingUsf
      esaRsfLoadFactor
      headcount {
        client
        architect
      }
      floors {
        id
        name
        floorNumber
        headcount {
          client
          architect
        }
        totalFloorUsf
        isMeasuredFromFloorplan
        rsfLoadFactor
        totalFloorRsf
        isRsfTotalLocked
        floorplan {
          id
        }
      }
    }
    spaceTypeCategories {
      id
      name
      icon
      parentId
      defaultSpaceTypeCategory {
        id
        category
        name
      }
      subcategories {
        id
        name
        includeInTotalWorkSeats
        parentId
        defaultSpaceTypeCategory {
          id
          category
          name
        }
      }
    }
    programSummaryCardIcons {
      cardType
      iconPath
    }
  }
`;
